import { baseReportTypes, reportCheckboxOptions } from './shared/translations';

export function getReportCheckboxValue(value, name) {
    switch (name) {
        case reportCheckboxOptions.NumBookings.name:
            reportCheckboxOptions.NumBookings.value = value
            break;
        case reportCheckboxOptions.NumCancellations.name:
            reportCheckboxOptions.NumCancellations.value = value
            break;
        case reportCheckboxOptions.NumCourses.name:
            reportCheckboxOptions.NumCourses.value = value
            break;
        case reportCheckboxOptions.NumHours.name:
            reportCheckboxOptions.NumHours.value = value
            break;
        case reportCheckboxOptions.ParticipantInfo.name:
            reportCheckboxOptions.ParticipantInfo.value = value
            break;
        default:
            break;
    }
}

export const filterReportFormComponents = (formValues, formComponents) =>
    formComponents.filter((component) => {
        if (formValues.baseType.value === baseReportTypes.Teacher.value && formValues.numHours === true) {
            return component.propName !== "courseSuggestions" &&
                component.propName !== "numBookings" &&
                component.propName !== "numCancellations" &&
                component.propName !== "participantInfo" &&
                component.propName !== "includeCancelledParticipants";
        }
        if (formValues.baseType.value === baseReportTypes.Teacher.value) {
            return component.propName !== "courseSuggestions" &&
                component.propName !== "numBookings" &&
                component.propName !== "numCancellations" &&
                component.propName !== "startDate" &&
                component.propName !== "endDate" &&
                component.propName !== "participantInfo" &&
                component.propName !== "includeCancelledParticipants";
        }
        if (formValues.baseType.value === baseReportTypes.AllTeachers.value && formValues.numHours === true) {
            return component.propName !== "courseSuggestions" &&
                component.propName !== "numBookings" &&
                component.propName !== "numCancellations" &&
                component.propName !== "participantInfo" &&
                component.propName !== "teacherSuggestions" &&
                component.propName !== "includeCancelledParticipants";
        }
        if (formValues.baseType.value === baseReportTypes.AllTeachers.value) {
            return component.propName !== "courseSuggestions" &&
                component.propName !== "numBookings" &&
                component.propName !== "numCancellations" &&
                component.propName !== "startDate" &&
                component.propName !== "endDate" &&
                component.propName !== "participantInfo" &&
                component.propName !== "teacherSuggestions" &&
                component.propName !== "includeCancelledParticipants";
        }
        if (formValues.baseType.value === baseReportTypes.Course.value) {
            return component.propName !== "teacherSuggestions" &&
                component.propName !== "numCourses" &&
                component.propName !== "numHours" &&
                component.propName !== "startDate" &&
                component.propName !== "endDate" &&
                (formValues.participantInfo === true || component.propName !== "includeCancelledParticipants");
        }
        if (formValues.baseType.value === baseReportTypes.AllCourses.value) {
            return component.propName !== "teacherSuggestions" &&
                component.propName !== "courseSuggestions" &&
                component.propName !== "numCourses" &&
                component.propName !== "numHours" &&
                (formValues.participantInfo === true || component.propName !== "includeCancelledParticipants");
        }

        if (formValues.baseType.value === baseReportTypes.AllCertificates.value
            || formValues.baseType.value === baseReportTypes.BonusCertificates.value) {
            return component.propName !== "courseSuggestions" &&
                component.propName !== "teacherSuggestions" &&
                component.propName !== "numBookings" &&
                component.propName !== "numCancellations" &&
                component.propName !== "numCertifications" &&
                component.propName !== "participantInfo" &&
                component.propName !== "numCourses" &&
                component.propName !== "numHours" &&
                component.propName !== "includeCancelledParticipants";
        }
    });

export function validateReportCheckboxesForCourseReport() {
    if (reportCheckboxOptions.NumBookings.value === false
        && reportCheckboxOptions.NumCancellations.value === false
        && reportCheckboxOptions.ParticipantInfo.value === false) {

        return false;
    }
    return true;
}

export function validateReportCheckboxesForTeacherReport() {
    if (reportCheckboxOptions.NumCourses.value === false && reportCheckboxOptions.NumHours.value === false) {
        return false;
    }
    return true;
}
